import React, { useEffect, useState, useRef } from "react";
import {useNavigate} from 'react-router-dom'
import img1 from "../../../Assets/Home/hero11.jpeg";
import img2 from "../../../Assets/Home/hero22.jpeg";
import img3 from "../../../Assets/Home/hero33.jpeg";
import img4 from "../../../Assets/Home/hero44.jpeg";
import img5 from "../../../Assets/Home/hero55.jpeg";
import { ChevronLeft, ChevronRight } from "lucide-react";

const heroData = [
  {
    type: "Service",
    index: "01",
    title: "AI-Native Supply Chain Transformation",
    image: img1,
    slug: "/service/ai-supply-chain",
  },
  {
    type: "Service",
    index: "02",
    title: "Enterprise Transformation Powered by SAP",
    image: img2,
    slug: "/service/sap-consulting",
  },
  {
    type: "Product",
    index: "04",
    title: "Building Predictive Supply Chains Through Demand Forecasting",
    image: img4,
    slug: "/product/demand-forecasting",
  },
  {
    type: "Product",
    index: "05",
    title: "EDI Tracking Reimagined",
    image: img5,
    slug: "/product/edifai",
  },
];

 // {
  //   type: "Service",
  //   index: "03",
  //   title: "Cloud Integration Built for Scalability & Innovation",
  //   image: img3,
  //   slug: "/service/cloud-migration",
  // },

// Simple transition hook
function useTransition(value, duration = 500) {
  const [display, setDisplay] = useState(value);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    setVisible(false);

    const t = setTimeout(() => {
      setDisplay(value);
      setVisible(true);
    }, duration / 2);

    return () => clearTimeout(t);
  }, [value, duration]);

  return { display, visible };
}


export default function HeroSection() {
  const [index, setIndex] = useState(0);
  const [progress, setProgress] = useState(0);
  const intervalRef = useRef(null);
  const progressRef = useRef(null);
  const navigate = useNavigate();
const { display: currentSlide, visible } = useTransition(
    heroData[index],
    600
  );

  const accent = currentSlide?.accent || "#00E5A0";

  // ---------------- PROGRESS ----------------
  const startProgress = () => {
    clearInterval(progressRef.current);

    let p = 0;
    setProgress(0);

    progressRef.current = setInterval(() => {
      p += 100 / 60;

      if (p >= 100) {
        p = 100;
        clearInterval(progressRef.current);
      }

      setProgress(p);
    }, 100);
  };

  // ---------------- AUTOSLIDE ----------------
  const startAutoSlide = () => {
    clearInterval(intervalRef.current);

    intervalRef.current = setInterval(() => {
      setIndex((prev) => (prev + 1) % heroData.length);
      startProgress();
    }, 6000);
  };

  // ---------------- RESET TIMER ----------------
  const resetSlider = () => {
    startProgress();
    startAutoSlide();
  };

  // ---------------- INITIAL ----------------
  useEffect(() => {
    resetSlider();

    return () => {
      clearInterval(intervalRef.current);
      clearInterval(progressRef.current);
    };
  }, []);

  // ---------------- NAVIGATION ----------------
  const goTo = (i) => {
    setIndex(i);
    resetSlider();
  };

  const prevSlide = () => {
    setIndex((prev) => {
      return (prev - 1 + heroData.length) % heroData.length;
    });

    resetSlider();
  };

  const nextSlide = () => {
    setIndex((prev) => {
      return (prev + 1) % heroData.length;
    });

    resetSlider();
  };

  // ---------------- ROUTE ----------------
  const handleNavigate = (slug) => {
    navigate(slug);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section className="relative w-full h-screen   overflow-hidden flex flex-col pt-[92px">

      <div
        className="pointer-events-none absolute top-[-180px] right-[-180px] w-[600px] h-[600px] rounded-full blur-[120px] opacity-20 transition-all duration-1000"
        style={{ background: accent }}
      />
      <div
        className="pointer-events-none absolute bottom-[-100px] left-[-100px] w-[400px] h-[400px] rounded-full blur-[100px] opacity-10 transition-all duration-1000"
        style={{ background: accent }}
      />
      

     <button onClick={prevSlide} className="absolute left-4 bottom-10 lg:top-1/2 -translate-y-1/2 z-20 w-12 h-12 flex items-center justify-center rounded-full bg-black/30 backdrop-blur-md hover:bg-black/50 transition-all duration-300">
      <ChevronLeft size={30} className="text-gray-100 font-bold" />
    </button>
    <button onClick={nextSlide} className="absolute right-4 bottom-10 lg:top-1/2 -translate-y-1/2 z-20 w-12 h-12 flex items-center justify-center rounded-full bg-black/30 backdrop-blur-md hover:bg-black/50 transition-all duration-300">
      <ChevronRight size={30} className="text-gray-100 font-bold" />
    </button>

      {/* ── Main layout ── */}
      <div 
      className="relative z-10 flex flex-col lg:flex-row flex-1  bg-auto lg:h-[650px] "
     style={{ backgroundImage: `url(${currentSlide?.image})` }}
      >
      

       {/* ── LEFT PANEL ── */}
<div className="flex flex-col justify-start mt-32 gap-20 flex-1 px-8 pb-12 lg:px-16 lg:pb-16 xl:px-24 max-w-3xl h-full relative">
  {/* <div className="absolute inset-0 bg -gradient-to-r from-slate-100/90 via-slate-100/60 to-transparent" /> */}
  <div
    className="transition-all duration-500"
    style={{ opacity: visible ? 1 : 0, transform: visible ? "translateY(0)" : "translateY(24px)" }}
  >
    <h1
      className="font-bold text-3xl lg:text-5xl leading-loose tracking-wide text-gray-700"
      style={{ fontFamily: "'MADType', sans-serif" }}
    >
      {currentSlide?.title}
    </h1>
  </div>

  {/* CTA */}
  <div
    className="flex items-center gap-5 transition-all duration-500 delay-150"
    style={{ opacity: visible ? 1 : 0, transform: visible ? "translateY(0)" : "translateY(16px)" }}
  >
    <button
      onClick={() => handleNavigate(currentSlide?.slug, currentSlide.type)}
      className="flex items-center gap-3 px-7 py-4 rounded-xl text-sm font-bold tracking-wide bg-gray-900 text-white hover:bg-gray-800 transition-all duration-300 hover:scale-[1.03] active:scale-[0.97]"
      style={{ fontFamily: "'Syne', sans-serif" }}
    >
      <span>Learn more</span>
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
      </svg>
    </button>
  </div>

  {/* Slide indicators */}
  <div className="flex items-center gap-6">
    {heroData.map((_, i) => (
      <button key={i} onClick={() => goTo(i)} className="relative flex flex-col items-start gap-2">
        <div className="w-8 h-0.5 bg-gray-300 rounded-full overflow-hidden">
          {i === index && (
            <div className="h-full rounded-full bg-gray-900 transition-none" style={{ width: `${progress}%` }} />
          )}
          {i < index && <div className="h-full w-full rounded-full bg-gray-400" />}
        </div>
      </button>
    ))}
  </div>
</div>
      </div>

      {/* ── Syne font import ── */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800;900&family=DM+Sans:wght@300;400;500&display=swap');
      `}</style>
    </section>
  );
}